<template>
  <main>
    <b-container v-if="currentUser">
      <div class="page-breadcrumb">
        <router-link :to="{ name: 'UserIndex' }">
          <i class="fa fa-angle-left" /> Back to users
        </router-link>
      </div>

      <div class="section-header">
        <h1 class="m-0">
          <!-- {{ currentUser.full_name }} -->
          User details
        </h1>

        <div class="actions">
          <!-- <b-btn variant="primary" @click="confirmDelete" class="mr-1">
            <i class="fa fa-trash" />
            Delete user
          </b-btn> -->
          <b-btn 
            v-if="authenticatedUserId === currentUser._id"
            variant="primary"
            :to="{
              name: 'UserEdit',
              params: { id: currentUser._id },
            }"
          >
            <i class="fa fa-pencil-alt" />
            Edit user
          </b-btn>
        </div>
      </div>

      <div class="layoutcard">
        <table class="table table-hover vertical-align-middle">
          <tbody>
            <tr>
              <th>Full Name</th>
              <td>
                {{
                  this.currentUser.full_name == "null null" ? "---" : currentUser.full_name
                }}
              </td>
            </tr>
            <tr>
              <th>Email</th>
              <td>
                <a :href="'mailto:' + currentUser.email">
                  {{
                    this.currentUser.email == null ? "---" : currentUser.email
                  }}
                </a>
              </td>
            </tr>
            <tr>
              <th>Created</th>
              <td>{{ currentUser.created }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!--
      <h2 class="mt-5">Projects</h2>

      <table class="table custom-padding vertical-align-middle mt-3">
        <tr v-for="project in currentUserProjects" :key="project._id">
          <td>
            <router-link
              :to="{ name: 'ProjectView', params: { id: project._id } }"
            >
              {{ project.name }}
            </router-link>
          </td>
          <td class="text-right">
            <b-badge class="p-2" variant="light">{{ project.tag }}</b-badge>
          </td>
        </tr>
      </table>
      -->
    </b-container>
  </main>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";
import InitAdmin from "../Shared/InitAdmin";

export default {
  name: "UserView",
  extends: InitAdmin,
  data() {
    return {
      currentUser: null,
    };
  },
  computed: {
    ...mapGetters(["authenticatedUserId","projects"]),
    ...mapState({
      users: (state) => state.user.users,
    }),
    currentUserProjects() {
      if (this.projects.length === 0) {
        return [];
      }

      return this.projects.filter((p) => {
        return p.users.some((u) => u.user === this.currentUser._id);
      });
    },
  },
  mounted() {
    this.currentUser = _.find(
      this.users,
      (user) => this.$route.params.id === user._id
    );
  },
  methods: {
    ...mapActions(["loadUser"]),
  },
};
</script>
